export default "__VITE_ASSET__2V60SbQT__"